import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/customerMismatch/user.customerMismatch.query.gql"
import type {
  UserCustomerMismatchQuery,
  UserCustomerMismatchQueryVariables,
} from "@/v2-backoffice-client/user/customerMismatch/__types__/user.customerMismatch.query"

type Options = QueryHookOptions<
  UserCustomerMismatchQuery,
  UserCustomerMismatchQueryVariables
>

export function useUserCustomerMismatchQuery(options?: Options) {
  return useQuery<
    UserCustomerMismatchQuery,
    UserCustomerMismatchQueryVariables
  >(query, options)
}
